// Theme color constants for consistent styling across the application

export const THEME_COLORS = {
  // Dark theme colors
  dark: {
    // Background gradient colors (even darker than before)
    background: {
      // Previous values:
      // primary: '#0f172a',    // slate-900 (darker than previous #111827)
      // secondary: '#020617',  // slate-950 (much darker for gradient middle)
      
      // New even darker values:
      primary: '#0a0f1a',    // Much darker custom color
      secondary: '#000000',  // Pure black center for maximum depth
      tertiary: '#1e293b',   // slate-800 (for cards/secondary backgrounds)
    },
    // Text colors
    text: {
      primary: '#ffffff',
      secondary: '#cbd5e1',  // slate-300
      tertiary: '#94a3b8',   // slate-400
      inverse: '#1f2937',
    },
    // Border colors
    border: {
      primary: '#334155',    // slate-700
      secondary: '#475569',  // slate-600
    },
    // Component-specific colors
    card: {
      background: '#1e293b', // slate-800
      border: '#334155',     // slate-700
    },
    player: {
      background: '#0f172a', // Same as primary background for seamless integration
    },
  },
  
  // Light theme colors
  light: {
    // Background gradient colors
    background: {
      primary: '#ffffff',
      secondary: '#f8fafc',  // slate-50
      tertiary: '#f1f5f9',   // slate-100
    },
    // Text colors
    text: {
      primary: '#1f2937',    // gray-800
      secondary: '#6b7280',  // gray-500
      tertiary: '#9ca3af',   // gray-400
      inverse: '#ffffff',
    },
    // Border colors
    border: {
      primary: '#e2e8f0',    // slate-200
      secondary: '#cbd5e1',  // slate-300
    },
    // Component-specific colors
    card: {
      background: '#ffffff',
      border: '#e2e8f0',     // slate-200
    },
    player: {
      background: '#f8fafc', // slate-50
    },
  },
} as const;

// Gradient generator functions
export const createBackgroundGradient = (theme: 'light' | 'dark'): string => {
  const colors = THEME_COLORS[theme].background;
  return `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 50%, ${colors.primary} 100%)`;
};

// Helper function to get theme colors
export const getThemeColors = (theme: 'light' | 'dark') => THEME_COLORS[theme];
